import { type Spritemap } from "@webbloqs/elements/lib/icon/spritemap";
import { initGlobals } from "@webbloqs/react/lib/global";
import { setLanguage } from "@webbloqs/react/lib/i18n";
import { initProjectConfiguration } from "@quatico/magellan-client/lib/transport";
import { MicroFrontendApplication } from "@qs/app-shell-react";
import {
    CPQ_AUTH_ENDPOINT,
    CPQ_AUTH_NAMESPACE,
    CPQ_NO_AUTH_ENDPOINT,
    CPQ_NO_AUTH_NAMESPACE,
    TRANSPORT_NAME,
    cdsFetchFn,
} from "@qs/cds-cpq-shared";
import { createApplicationConfiguration } from "./demo-app-configuration";
import { injectWebbloqsStyles } from "./webbloqs-styles";

// PUBLIC_SERVER_URL is defined by webpack.DefinePlugin
const PUBLIC_SERVER_URL = `${globalThis.window.location.origin}/cds/cpq/ui`;

// DEVELOPER NOTE: To switch between providers, you have 3 options:
// 1. CLI argument (recommended):  pnpm run serve --provider=my-provider-id
// 2. Change this constant:        const PROVIDER_ID = "my-provider-id"
// 3. Environment variable:        CPQ_PROVIDER_ID=my-provider-id pnpm run serve
const PROVIDER_ID = "crif"; // <-- Option 2: Change this to switch providers

// await is only valid in async functions and the top level bodies of modules
export default async () => {
    const spritemapJson = (await fetch(`${PUBLIC_SERVER_URL}/assets/icons-spritemap.json`)
        .then(res => res.json())
        .catch(() => undefined)) as Spritemap;

    return await new MicroFrontendApplication()
        .loadConfiguration(createApplicationConfiguration(PUBLIC_SERVER_URL, PROVIDER_ID))
        .start({
            beforeAll: () => {
                initGlobals({
                    spritemap: spritemapJson,
                    enableCustomMediaQueries: true,
                    publicPath: "/cds/cpq/ui/assets",
                });
                injectWebbloqsStyles();
                initProjectConfiguration({
                    namespaces: {
                        [CPQ_NO_AUTH_NAMESPACE]: {
                            endpoint: CPQ_NO_AUTH_ENDPOINT,
                            transport: TRANSPORT_NAME,
                        },
                        [CPQ_AUTH_NAMESPACE]: {
                            endpoint: CPQ_AUTH_ENDPOINT,
                            transport: TRANSPORT_NAME,
                        },
                    },
                    transports: {
                        [TRANSPORT_NAME]: cdsFetchFn,
                    },
                });
            },
            afterAll: () => {
                // Detect locale from the current page filename
                // index.en.html -> "en", index.html -> "de"
                const pathname = window.location.pathname;
                const filename = pathname.substring(pathname.lastIndexOf("/") + 1);
                const match = filename.match(/\.([a-z]{2})\.html$/);
                const locale = match?.[1] ?? "de";
                setLanguage(locale);

                // Set locale cookie so API calls use the correct language
                document.cookie = `cds-cpq-locale=${locale}; path=/; max-age=${30 * 24 * 60 * 60}; SameSite=Lax`;
            },
        });
};
